import { Popover } from "react-bootstrap";

interface Props {
  description: string;
}

export default function OverlayDescription({ description }: Props) {
  return (
    <Popover
      style={{
        borderRadius: 15,
        margin: 0,
        zIndex: 999,
      }}
    >
      <Popover.Body>
        <b>{description}</b>
      </Popover.Body>
    </Popover>
  );
}
